import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

export const CopyWithRovoLoadable: LoadableType<{
	contentId: string;
}> = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-CopyWithRovo" */ '../src/CopyWithRovo.tsx'))
			.CopyWithRovo,
	loading: () => null,
});
